// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__30bph","footer":"ReportModalFilter_footer__2728s"};